import { LocalService } from 'src/app/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Errors, ManagerService } from '../../core';
import { PopupMessageService } from '../../shared/message/services/message.service';
@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})
export class LeaderboardComponent implements OnInit {
  selectedTab: string = 'salesChallenge';
  errors: Errors = { errors: {} };
  userData: any;
  isGeneralLeaderboardActive: boolean = false;
  isManager: boolean = false;
  afterDataLoad: boolean = false;
  isOptOut: boolean = false;
  pamData: any = '';
  tabs: any[] = [];

  constructor(
    private router: Router,
    private managerService: ManagerService,
    private popupMessageService: PopupMessageService,
  ) { }


  ngOnInit() {
    this.userData = LocalService.get('userProfile');
    console.log('userData', this.userData);

    if (this.router.url.includes('manager')) {
      this.isManager = true;
    }

    this.getCompanyPreferences();
    this.getUserPreferences(10);

    if (this.userData.userType === 'PAM') {
      this.pamData = LocalService.get('pamData');
    }

    this.initializeTabs();

  }

  initializeTabs() {
    this.tabs = [
      {
        id: 'salesChallenge',
        label: 'leaderboard.tab1',
        icon: 'assets/images/icons/star.svg',
        isActive: true,
        isVisible: true,
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-dollar-sign h-4 w-4">
              <line x1="12" x2="12" y1="2" y2="22"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>`
      },
      {
        id: 'activityChallenge',
        label: 'leaderboard.tab2',
        icon: 'assets/images/icons/activities.svg',
        isActive: false,
        isVisible: true,
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"/>
                </svg>`
      },
      {
        id: 'cisco',
        label: 'leaderboard.tab7',
        icon: 'assets/images/icons/star.svg',
        isActive: false,
        isVisible: this.isManager,
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-4 w-4"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>`
      },
      {
        id: 'partnerPerformence',
        label: 'leaderboard.tab8',
        icon: 'assets/images/icons/network.svg',
        isActive: false,
        isVisible: this.userData && this.userData.userType === 'PAM',
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-building2 h-4 w-4"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path><path d="M10 6h4"></path><path d="M10 10h4"></path><path d="M10 14h4"></path><path d="M10 18h4"></path></svg>`
      },
      {
        id: 'leaderboardChallenge',
        label: 'leaderboard.tab9',
        icon: 'assets/images/icons/graph.svg',
        isActive: false,
        isVisible: this.userData && this.userData.company && this.userData.company.region === 'APJ',
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trophy h-4 w-4"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path><path d="M4 22h16"></path><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path></svg>`
      }
    ];
  }

  getUserPreferences(preferenceId: any) {
    const params = {
      userId: this.userData.id,
      preferenceId: preferenceId
    };
    this.managerService.getUserPreferences(params).subscribe((data) => {
      this.isOptOut = data.enabled;
    }, err => {
      this.errors = err;
    });
  }

  onTabChange(selectedTab: string) {
    this.selectedTab = selectedTab;
  }

  getCompanyPreferences() {
    this.managerService.getCompanyTypePreferences().subscribe((data) => {
      console.log('[getCompanyPreferences] getCompanyTypePreferences response:', data);

      const tabName = 'COMPANY_SELLER_GENERAL_LEADERBOARD';
      const preferenceType = data.filter((item: any) => item.name === tabName);
      const preference = preferenceType.map((item: any) => item.id)[0];
      console.log('[getCompanyPreferences] matched preferenceType:', preferenceType, '| preferenceId:', preference);

      if (this.userData.company && this.userData.company.id) {
        const companyParams = {
          companyId: this.userData.company.id,
          preferenceId: preference
        };
        console.log('[getCompanyPreferences] calling getCompanyPreferences with params:', companyParams);

        this.managerService.getCompanyPreferences(companyParams).subscribe((data) => {
          console.log('[getCompanyPreferences] getCompanyPreferences response:', data);
          this.isGeneralLeaderboardActive = data.companyPreferences.map((item: any) => item.enabled)[0];
          console.log('[getCompanyPreferences] isGeneralLeaderboardActive:', this.isGeneralLeaderboardActive);
          this.afterDataLoad = true;
        }, err => {
          console.error('[getCompanyPreferences] getCompanyPreferences error:', err);
          this.errors = err;
        });
      } else {
        console.warn('[getCompanyPreferences] userData.company or company.id is missing:', this.userData.company);
      }
    }, err => {
      console.error('[getCompanyPreferences] getCompanyTypePreferences error:', err);
      this.errors = err;
    });
  }

  toggleOptOut(): void {
    const event = { checked: !this.isOptOut };
    this.isChallengeEnablechange(event);
  }

  isChallengeEnablechange(event: any) {
    const id = this.userData.id;
    const sellerParams = {
      userId: id,
      preferenceId: 10,
      enabled: event.checked,
    };
    this.managerService.postSellerPreferences(sellerParams).subscribe((data) => {
      const lang = localStorage.getItem('selectedLanguage');
      let msg = 'Updated successfully.';
      if (lang == 'Korean') {
        msg = '도전이 성공적으로 업데이트되었습니다.';
      }
      if (lang == 'Japanese') {
        msg = 'チャレンジが正常に更新されました。';
      }
      this.popupMessageService.showSuccess(msg, 'success');
      this.isOptOut = data.enabled;
    },
      err => {
        this.errors = err;
      });

    this.getUserPreferences(10);
  }
}
